// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__lv-09","approved":"Status_approved__8olc7","rejected":"Status_rejected__2PBoz","expired":"Status_expired__f4AH6","label":"Status_label__XUVPF"};